import React, { ReactElement } from "react";
import { StepProps } from "../TradeModal";
import { formatCurrency } from "@tiicker/util/lib/formats";
import { format } from "date-fns";
import { brokerDetailMapping } from "components/BrokerConnectionMessage/BrokerConnectionMessage";
import Button from "components/core/Button/Button";

export default function TradeConfirmation(props: StepProps): ReactElement {
  props.setTitle("Order Message Confirmation");

  const limitPrice = props.state.tradePreview?.limitPrice;
  const limitMessage = limitPrice
    ? ` with a limit price of ${formatCurrency(limitPrice)}`
    : "";

  const stopPrice = props.state.tradePreview?.stopPrice;
  const stopMessage = stopPrice
    ? ` with a stop price of ${formatCurrency(stopPrice)}`
    : "";

  const brokerName = brokerDetailMapping[props.state.brokerName || ""]?.name;

  return (
    <div>
      <p data-cy="trade-confirmation-message">
        Your order message to {props.state.tradePreview?.side}{" "}
        {props.state.tradePreview?.quantity} share
        {(props.state.tradePreview?.quantity || 0) > 1 && "s"} of{" "}
        {props.state.tradePreview?.symbol}
        {limitMessage}
        {stopMessage} at a total estimated price of{" "}
        {formatCurrency(props.state.tradePreview?.orderCost || 0)} has been
        successfully transmitted to {brokerName} at{" "}
        {format(new Date(), "d/L/yy h:mma z")}.
      </p>

      {props.state.isNative ? (
        <p>You can now close this window.</p>
      ) : (
        <Button onClick={props.closeModal}>Continue</Button>
      )}
    </div>
  );
}
